__webpack_require__.p = "/Portfolio-Shawn-Roggero/";